const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1aedf29fdb61e0b22cfcc80cb7023d77dc43bea0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["datastory-website@datastory-7q"]={id:"1aedf29fdb61e0b22cfcc80cb7023d77dc43bea0"};
      